module.exports = __webpack_public_path__ + "img/hitradio-oe3.6a43162.svg";